<div class="loginMain">
  <p class="loginTitle">TRACK & TRACE</p>
  <mat-divider style="width: 100%" color="white"></mat-divider>
  <p class="loginSubTitle">Mobile app</p>
  <form
    [formGroup]="loginGroup"
    (ngSubmit)="login()"
    autocomplete="off"
    >
    <mat-form-field class="loginFormField" id="usernameField">
      <label for="username" class="loginLabel">Username *</label><br />
      <input
        type="text"
        matInput
        aria-label="String"
        formControlName="username"
        class="loginInput"
        name="username"
        id="username"
        autocapitalize="off"
        /><br />
      </mat-form-field>
      <mat-form-field class="loginFormField" id="passwordField">
        <label for="password" class="loginLabel">Password *</label><br />
        <input
          type="password"
          matInput
          aria-label="String"
          formControlName="password"
          (keydown.enter)="login()"
          id="password"
          class="loginInput"
          name="password"
          /><br />
        </mat-form-field>
        <div class="loginDiv">
          <button
            class="loginConfirm"
            type="submit"
            [disabled]="!loginGroup.valid || tryingToLog"
            >
          @if (!tryingToLog) {
            <p class="loginConfirmText">Login</p>
          }
          @if (tryingToLog) {
            <div class="loader">Loading...</div>
          }
        </button>
      </div>
    </form>

    <div class="loginDivLogo">
      <img class="loginLogo" src="assets/Stellantis.svg" />
    </div>

    @if (credentialError) {
      <div class="loginError">
        Invalid credentials. Please check your username and password.
      </div>
    }
    @if (connexionError) {
      <div class="loginError">
        Unable to reach the server. Please check your internet connection.
      </div>
    }
  </div>
